import { type CalendarEvent } from '../../CalendarEvent'
import dayjs from 'dayjs'

export function getGroupedEvents(events: CalendarEvent[]): CalendarEvent[][] {
  // ensure dates are dayjs objects before using them
  const filteredEvents = events.filter(Boolean).map((event) => ({
    ...event,
    startDate: dayjs.isDayjs(event.startDate)
      ? event.startDate
      : dayjs(event.startDate),
    endDate: dayjs.isDayjs(event.endDate)
      ? event.endDate
      : dayjs(event.endDate),
  }))

  const temporaryEvent = filteredEvents.find(
    (event) => event.id === 'temporary'
  )
  const oldSort = filteredEvents.filter((event) => event.id !== 'temporary')

  // Sort the filtered events, not the original events array
  const sortedEvents = [...filteredEvents].sort(
    (a, b) => a.startDate.valueOf() - b.startDate.valueOf()
  )

  const result: CalendarEvent[][] = []
  let currentGroup: CalendarEvent[] = []
  let currentGroupIDs: string[] = []

  if (temporaryEvent) {
    result.push([temporaryEvent])
  }

  // Iterate over sorted filtered events, not the original events array
  for (const currentEvent of sortedEvents) {
    let overlapFound = false
    for (const previousEvent of currentGroup) {
      // Safe to call isBefore/isAfter since events are validated at the query layer
      if (
        currentEvent.startDate.isBefore(previousEvent.endDate) &&
        currentEvent.endDate.isAfter(previousEvent.startDate)
      ) {
        overlapFound = true
        break
      }
    }

    if (overlapFound) {
      currentGroup.push(currentEvent)
      currentGroupIDs.push(currentEvent.id)
    } else {
      // Only push the previous group if it has events
      if (currentGroup.length > 0) {
        const currentGroupIDsSet = new Set(currentGroupIDs)
        const groupEvents = oldSort.filter((event) =>
          currentGroupIDsSet.has(event.id)
        )
        if (groupEvents.length > 0) {
          result.push(groupEvents)
        }
      }
      currentGroup = [currentEvent]
      currentGroupIDs = [currentEvent.id]
    }
  }

  // Push the final group if it has events
  if (currentGroup.length > 0) {
    const currentGroupIDsSet = new Set(currentGroupIDs)
    const groupEvents = oldSort.filter((event) =>
      currentGroupIDsSet.has(event.id)
    )
    if (groupEvents.length > 0) {
      result.push(groupEvents)
    }
  }

  return result
}
